import React from 'react';
import Carousel from 'react-elastic-carousel';

import './testimonials.scss';

interface TestimonialProps {
    Customer: string;
    Quote: string;
}

export const testimonials: Array<TestimonialProps> = [
    {
        Customer: 'Moabi Litheko',
        Quote: 'I have a relationship that spans 25 years with these companies Spektra Financial Services and Prisma Rekenmeesters. I first met Messrs. Christo Viljoen and Gerhard Labuschagne in 1996 and as the saying goes, “the rest is history”. Investments and Tax returns are done under one roof in what could be referred to as a 1-stop shop.'
    },
    {
        Customer: 'Dr EML Strydom',
        Quote: 'Retirement can be extremely stressful. However, Prispek’s continued professional and ethical advice regarding my investments (Spektra Financial Services CC) and tax issues (Prisma Accountants) have enabled me to retire with dignity and complete peace of mind.'
    },
    {
        Customer: 'Dr EML Strydom',
        Quote: 'Professional and ethical advice to create wealth and ensure a dignified retirement.'
    }
];

export const Testimonials: React.FC = React.memo(() => {
    const [grabbing, setGrabbing] = React.useState<boolean>(true);
    return (
        <div
            style={{
                padding: '2rem',
                textAlign: 'center',
                cursor: 'grabbing'
                // cursor: grabbing ? 'grabbing' : 'grab'
                // '&:hover': { boxShadow: '0 0 6px rgba(0,0,0,0.5)' }
            }}
            onDragStart={() => setGrabbing(true)}
            onDragOver={() => setGrabbing(false)}
        >
            <Carousel
                isRTL={false}
                itemsToShow={1}
                autoPlaySpeed={6000}
                showArrows={false}
                enableAutoPlay
            >
                {testimonials.map(item => (
                    <div key={item.Quote} style={{ padding: '2rem 0' }}>
                        <q
                            style={{
                                fontSize: '1.9rem',
                                letterSpacing: '1.5px',
                                lineHeight: 1.5
                            }}
                        >
                            {item.Quote}
                        </q>
                        <p
                            style={{
                                fontSize: '2rem',
                                letterSpacing: '1.5px',
                                marginTop: '1rem',
                                fontWeight: 500
                            }}
                        >
                            — {item.Customer} —
                        </p>
                    </div>
                ))}
            </Carousel>
        </div>
    );
});
